(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var MenuKnow = {
        
        init: function init() 
        {        
            var btn = document.querySelectorAll('.btnKnow');
        
            //console.log(window.location.href);
            //console.log(btn);        

            var loop = function ( i ) {

                for (var y = 0; y < btn[i].children[2].children.length; y++) {
                    if(btn[i].children[2].children[y].children[0].href == window.location.href){
                        //console.log(btn[i].children[2].children[y].children[0]);
                        btn[i].children[0].checked = true;
                        btn[i].classList.add('whitebc');
                        btn[i].children[2].children[y].children[0].classList.add('active-link');

                        if(btn[i].parentElement.parentElement.classList.contains('btnKnow'))  {
                            //console.log("in");
                            btn[i].parentElement.parentElement.children[0].checked = true;
                            btn[i].parentElement.parentElement.classList.add('whitebc');

                            if(btn[i].parentElement.parentElement.parentElement.parentElement.classList.contains('btnKnow'))  {
                                //console.log("in");
                                btn[i].parentElement.parentElement.parentElement.parentElement.children[0].checked = true;
                                btn[i].parentElement.parentElement.parentElement.parentElement.classList.add('whitebc');
                            }  
                        }                 
                    }
                }
                
                btn[i].children[1].addEventListener('click', function() {
                    //console.log(btn[i].children[2].children)
                    
                    if (btn[i].classList.contains('whitebc')) {
                        btn[i].classList.remove('whitebc');
                        //console.log("remove");
                    }
                    else {
                        btn[i].classList.add('whitebc');
                    }
                });
            };

            for (var i = 0; i < btn.length; i++) loop( i );        
        }
    };

    var Profile = {
        
        init: function init() 
        {        
            var page = document.getElementById('user-profile');
            if(page){
                var progress = page.getElementsByClassName('elementor-widget-progress');

                //console.log(progress);

                for (var i = 0; i < progress.length; i++) {

                    if(progress[i].children[0].children[1].ariaValueNow == 0)
                    {
                        progress[i].style.display = "none";
                    }
                    //console.log(progress[i].children[0].children[1].ariaValueNow);
                }
            }        
        }
    };

    var Comment = {
        
        init: function init() 
        {        
            jQuery(".form-submit").find(".submit").attr("value", "Valider");

            var formComment = document.getElementById("commentform");
            if(typeof(formComment) != 'undefined' && formComment != null)
            {
                    formComment.style.display = "none";
            }
            

            var btnComment = document.getElementById("reply-title");
            if(typeof(btnComment) != 'undefined' && btnComment != null)
            {
                btnComment.style.cursor = "pointer";

                btnComment.addEventListener('click', function() {
                    
                    if (formComment.style.display == "none") {
                        formComment.style.display = "block";
                    }
                    else {
                        formComment.style.display = "none";
                    }
                });
            }
        


            
            
        }
    };

    window.elementorFrontend.elements.$window.one('elementor/frontend/init', function () {
        // Elementor frontend is loaded
        (function () {
            var Config = theme_config || {};
            MenuKnow.init();
            Profile.init();
            Comment.init();
        })();
    });

    window.addEventListener("load", function(event) {

        var profilBloc = document.getElementsByClassName('block-loaded');    
        
        if(profilBloc) {    
        
            for(var i = 0; i < profilBloc.length; i++) {
        
            if(typeof(profilBloc[i]) != 'undefined' && profilBloc[i] != null) {
            
                profilBloc[i].classList.remove('block-loading');
                
                }
            
            }
        
        }
        
    });

})));
//# sourceMappingURL=bpm.min.js.map
